import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Disponível ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Utilizado ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Total ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Regulamento")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "ion-padding" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, { class: "ion-text-center font-suls" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.campanha.titulo), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, { size: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.campanhas.iframe.show=true;_ctx.campanhas.iframe.url=_ctx.campanha.urlparticipacao})
              }, [
                _createElementVNode("img", {
                  src: _ctx.setImg(_ctx.campanha.imagem)
                }, null, 8, _hoisted_1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, { class: "ion-text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.campanhas.iframe.show=true;_ctx.campanhas.iframe.url=_ctx.campanha.urlparticipacao}),
                color: "jauservelayoutalter",
                expand: "block",
                shape: "round"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.campanha.btnparticipar), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            class: "ion-text-center font-suls",
            size: "4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.campanha.beneficio.disponivel), 1),
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, {
            class: "ion-text-center font-suls",
            size: "4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.campanha.beneficio.utilizado), 1),
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, {
            class: "ion-text-center font-suls",
            size: "4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.campanha.beneficio.total), 1),
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, {
            class: "ion-text-center font-suls",
            size: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.campanhas.iframe.show=true;_ctx.campanhas.iframe.url=_ctx.campanha.regulamento}),
                color: "jauservelayoutciza6",
                expand: "block",
                shape: "round"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_9,
      _hoisted_10,
      _hoisted_11
    ]),
    _: 1
  }))
}